import { createClient } from '@innerloopco/loopcms-core'

// Same origin in production (Fastify serves the SPA) and in development
// (Vite proxies /api), so the session cookie behaves identically in both.
export const api = createClient({ baseUrl: '' })
